import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Carlos', 'Ana', 'Juan', 'Sofía', 'Luis', 'Valentina', 'Diego', 'Camila', 'Javier', 'Lucía', 'Mateo', 'Isabella', 'Gabriel', 'Fernanda'];
const CITIES = [{
  city: 'Buenos Aires',
  country: 'Argentina'
}, {
  city: 'Ciudad de México',
  country: 'México'
}, {
  city: 'Bogotá',
  country: 'Colombia'
}, {
  city: 'Lima',
  country: 'Perú'
}, {
  city: 'Santiago',
  country: 'Chile'
}, {
  city: 'Montevideo',
  country: 'Uruguay'
}, {
  city: 'Quito',
  country: 'Ecuador'
}, {
  city: 'Medellín',
  country: 'Colombia'
}, {
  city: 'Guadalajara',
  country: 'México'
}, {
  city: 'Córdoba',
  country: 'Argentina'
}, {
  city: 'Caracas',
  country: 'Venezuela'
}, {
  city: 'Asunción',
  country: 'Paraguay'
}, {
  city: 'San José',
  country: 'Costa Rica'
}, {
  city: 'Ciudad de Panamá',
  country: 'Panamá'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    location: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name: randomName,
        location: `${randomCity.city}, ${randomCity.country}`
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 4000);
    // Random interval between 8-12 seconds
    const intervalId = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.random() * (12000 - 8000) + 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(intervalId);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-40 animate-in slide-in-from-bottom-10 fade-in duration-500" data-id="element-162">
      <div className="bg-white rounded-lg shadow-xl border-l-4 border-green-500 p-4 max-w-xs flex items-start gap-3" data-id="element-163">
        <div className="bg-green-100 p-2 rounded-full shrink-0" data-id="element-164">
          <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-165" />
        </div>
        <div data-id="element-166">
          <p className="text-sm font-medium text-gray-900" data-id="element-167">
            <span className="font-bold" data-id="element-168">{data.name}</span> acaba de comprar
          </p>
          <p className="text-xs text-gray-500 mt-0.5" data-id="element-169">Desde {data.location}</p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-170">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}